import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

const LinkGroupComponent = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin: 0 auto;

  .ant-radio-button-wrapper {
    align-items: center;
    display: inline-flex;
    height: var(--height-base);
    margin-right: 1px;
    padding: 0 var(--spacing-03);

    > svg {
      margin-right: var(--spacing-03);
    }

    &.active {
      border-color: var(--black-100);

      &:not(.ant-radio-button-wrapper-disabled)::before {
        background-color: var(--black-100);
      }
    }
  }
`;

interface AnchorProps {
  disabled?: boolean;
}
const Anchor = styled(NavLink).attrs<AnchorProps>({
  className: 'ant-radio-button-wrapper',
  exact: true,
})<AnchorProps>``;

type LinkGroup = typeof LinkGroupComponent & {
  Anchor: typeof Anchor;
};

const LinkGroup: LinkGroup = LinkGroupComponent as any;

LinkGroup.Anchor = Anchor;

export { LinkGroup };
